$(document).ready(()=> {
    $(".trigger-secondary").click(function() {
        $(this).hasClass("secondary-open")?$(this).removeClass("secondary-open"): $(this).addClass("secondary-open")
    }
    ), $("#menuToggle").click(()=> {
        $(".mobile-menu-container").addClass("open"), $(".mobile-menu").addClass("open"), $("html").css("overflow", "hidden"), $("body").css("overflow", "hidden")
    }
    ), $(".mobile-menu .close-menu").click(()=> {
        $(".mobile-menu").removeClass("open"), $(".mobile-menu-container").removeClass("open"), $("html").css("overflow", ""), $("body").css("overflow", "")
    }
    )
}

);
var featuredProductsSwiper=new Swiper(".collection-slider", {
    spaceBetween:25, slidesPerView:1.3, centeredSlides:!0, freeMode:!0, preloadImages:!1, lazy:!0, freeModeMomentumBounce:!1, navigation: {
        nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev"
    }
    , breakpoints: {
        600: {
            slidesPerView: 2.3, spaceBetween: 10, freeMode: !1, centeredSlides: !1
        }
        , 750: {
            slidesPerView: 4, freeMode: !1, centeredSlides: !1
        }
    }
}

),
heirloomsSwiper=new Swiper(".heirlooms-slider", {
    slidesPerView:"auto", spaceBetween:10, loop:!0, navigation: {
        nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev"
    }
    , breakpoints: {
        414: {
            slidesPerView: 1.3, spaceBetween: 40
        }
        , 750: {
            slidesPerView: 1, spaceBetween: 15
        }
        , 1301: {
            slidesPerView: 3, spaceBetween: 15
        }
    }
}

),
asSeenInSwiper=new Swiper(".seen-in-slider", {
    spaceBetween:25, slidesPerView:1.3, centeredSlides:!0, freeMode:!0, roundLengths:!0, freeModeMomentumBounce:!1, breakpoints: {
        600: {
            slidesPerView: 2.3, spaceBetween: 10, freeMode: !1, centeredSlides: !1
        }
        , 750: {
            slidesPerView: 3, spaceBetween: 20, freeMode: !1, centeredSlides: !1, touchRatio: 0,
        }
        , 1300: {
            slidesPerView: 3, spaceBetween: 60, freeMode: !1, centeredSlides: !1, touchRatio: 0,
        }
    }
}

),
testimonialSwiper=new Swiper(".testimonial-slider", {
    slidesPerView:1, loop:!1, navigation: {
        nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev"
    }
    , pagination: {
        el: ".swiper-pagination.testimonial", clickable: !0
    }
}

);
$(".link-container .double").parent().addClass("has-double");
var galleryThumbs=new Swiper(".gallery-thumbs", {
    spaceBetween:11, slidesPerView:6, breakpoints: {
        750: {
            direction: "vertical", spaceBetween: 1, centerInsufficientSlides: !1, slidesPerView: "auto"
        }
    }
}

),
galleryTop=new Swiper(".gallery-top", {
    slidesPerView:1, simulateTouch:!1, spaceBetween:15, navigation: {
        nextEl: ".swiper-button-next.article-arrows", prevEl: ".swiper-button-prev.article-arrows"
    }
    , breakpoints: {
        750: {
            direction: "vertical",
            slidesPerView: "auto",
            simulateTouch: "true",
            touchReleaseOnEdges: "true"
        }
    }
    , thumbs: {
        swiper: galleryThumbs
    }
}

),
matchingAccessories=new Swiper(".matching-accessories", {
    slidesPerView:2, spaceBetween:15, navigation: {
        nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev"
    }
}

),
customerStyles=new Swiper(".style-swiper", {
    slidesPerView:1.5, spaceBetween:36, roundLengths:!0, centerInsufficientSlides:!0, navigation: {
        nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev"
    }
    , breakpoints: {
        750: {
            slidesPerView: 3, watchOverflow: !0
        }
    }
}

),
heroSwiper=new Swiper(".hero-swiper", {
    direction:"vertical", touchReleaseOnEdges:!0, mousewheel: {
        releaseOnEdges: !0
    }
    , pagination: {
        el: ".swiper-pagination.hero-pagination", clickable: !0
    }
}

);
function swatchDelay() {
    $(".swatchColor").each(function() {
        $(this).hasClass("currentSwatch")&&$(".selected-swatch").text(": "+this.textContent)
    }
    ),
    $(".swatchColor").click(function() {
        $(".selected-swatch").text(": "+this.textContent)
    }
    )
}

setTimeout(function() {
    new Swiper(".recommendations-swiper", {
        slidesPerView:2.2, spaceBetween:20, roundLengths:!0, breakpoints: {
            750: {
                slidesPerView: 3, simulateTouch: !1
            }
            , 1024: {
                slidesPerView: 4, simulateTouch: !1
            }
        }
    }
    )
}

, 1e3),
$('[data-fancybox="gallery"], .customer-style').fancybox( {
    buttons: ["zoom", "close"]
}

),
$(".swatch-container").each(function() {
  var e = $(this).find(".selected-option");
  var i = $(this).find(".swatch-element");
  var atc = $('.details-container form .atc')
  var atcText = $('.details-container form .atc span')
  $(i).click(function() {
    $(e).text(": "+this.textContent)
    if ($(this).hasClass('soldout')) {
      atc.addClass('disabled');
      atcText.text('Sold Out');
    } else {
      atc.removeClass('disabled');
      atcText.text('ADD TO CART');
    }
  });
}

),
$(document).ready(function() {
    setTimeout(swatchDelay, 600), $(window).bind("resize", function() {
        $(this).width()>749&&$(".multiImage .gallery-thumbs, .details.multiImage").stick_in_parent( {
            offset_top: 70
        }
        )
    }
    ).trigger("resize")
}

),
$(document).ready(function() {
    $(".animsition").animsition( {
        inClass: "fade-in", outClass: "fade-out", loading: !1, inDuration: 600, outDuration: 200, browser: ["animation-duration", "-webkit-animation-duration"]
    }
    ), console.log("ready")
}

);